// config.js
const config = {
  username: process.env.REACT_APP_UNAME,
  password: process.env.REACT_APP_PWD,
  apiUrl: process.env.REACT_APP_API_URL,
  vehicle360Url: process.env.REACT_APP_VEHICLE_URL || "https://vehicle360.cv.tatamotors",
  dealer360Url: process.env.REACT_APP_DEALER_URL || "https://dealer360.cv.tatamotors",
};

export default config;
